const config = {
	//"apiBase": '/'   //un comment for Server
    "apiBase": 'http://elan-api-dev.incedopay.com', //un comment for local 
    "base_url": `${window.location.protocol}//${window.location.hostname}:${window.location.port}`,
    "env": process.env.REACT_APP_ENV || 'develop',
    
    // "base_url": `https://elan-qa-admin.payeecashin.com`,
    // "base_url": `http://elanwebapp-dev.tfnhdzy2me.us-east-2.elasticbeanstalk.com`,
    // "base_url": `http://localhost:8091`,
    }

export default config